export * from './ToggleSwitch';

import { ToggleSwitch } from './ToggleSwitch';

export default ToggleSwitch;
